import React, {Component} from 'react';
import { storage } from '../../../../firebase/index';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import axios from '../../../../axios-drops';
import Input from '../../../UI/Input/Input';
import withErrorHandler from '../../../../containers/hoc/withErrorHandler/withErrorHandler';

import Button from '../../../UI/Buttons/Button/Button';
import Aux from '../../../../containers/hoc/Auxiliary';
import Spinner from '../../Spinner/Spinner';

import noImage from '../../../../Images/no-image-icon.PNG';
import backIcon from '../../../../icons/return.svg';

import classes from './TrdEdit.css';

class TrdEdit extends Component {

    state = {
        inputForm: {
            name: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. Storm Trooper)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Name'
            },
            variant: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. Blue Meanie)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Variant'
            }, 
            edition: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. 35)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Edition'
            },
            availability: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. 33)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Number Available'
            },
            cost: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: '(ex. 30)'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Cost'
            }
        },
        formIsValid: false,
        loading: false,
        image: null,
        imageName: '',
        previousImage: '',
        deleteImageIfCancelled: false,
        currentURL: "",
        unlockSave: false,
        current: null,
        dropClosed: null, 
        type: null,
        originallyAvailable: null,
        saved: false,
        loadSuccessful: false,
        progress: 100,
        imageURL: { 
            validation: {
                required: true
            },
            valid: false,
            touched: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)

       const func = async () => {
           await axios.get('/drops/' + this.props.match.params.id + '.json')
            .then(response => {
                // console.log(response.data)
                this.setFormValues(response.data)
            })
            .catch(error => {

            })
       }

       func()
        
    }

    setFormValues = (data) => {
        // console.log(data.showInfo)
        
        const updatedInputForm = {
            ...this.state.inputForm
        }

        const updatedImage = {
            ...this.state.imageURL
        }

        // console.log(updatedInputForm.name)
        const updatedFormName = {
            ...updatedInputForm.name
        }
        const updatedFormVariant = {
            ...updatedInputForm.variant
        }
        const updatedFormEdition = {
            ...updatedInputForm.edition
        }
        const updatedFormAvailability = {
            ...updatedInputForm.availability
        }
        const updatedFormCost = {
            ...updatedInputForm.cost
        }

        updatedImage.valid = true
        updatedImage.touched = true
 
        updatedFormName.value = data.name;
        updatedFormName.valid = true;
        updatedFormName.touched = true;

        updatedFormVariant.value = data.variant;
        updatedFormVariant.valid = true;
        updatedFormVariant.touched = true;

        updatedFormEdition.value = data.edition;
        updatedFormEdition.valid = true;
        updatedFormEdition.touched = true;

        updatedFormAvailability.value = data.availability;
        updatedFormAvailability.valid = true;
        updatedFormAvailability.touched = true;

        updatedFormCost.value = data.cost;
        updatedFormCost.valid = true;
        updatedFormCost.touched = true;
        

        updatedInputForm.name = updatedFormName;
        updatedInputForm.variant = updatedFormVariant;
        updatedInputForm.edition = updatedFormEdition;
        updatedInputForm.availability = updatedFormAvailability;
        updatedInputForm.cost = updatedFormCost;
        
        this.setState({inputForm: updatedInputForm,
                        formIsValid: true,
                        imageURL: updatedImage,
                        currentURL: data.image,
                        current: data.current,
                        type: data.type,
                        showInfo: data.showInfo,
                        dropClosed: data.dropClosed,
                        unlockSave: true,
                        previousImage: data.imageName,
                        imageName: data.imageName,
                        originallyAvailable: data.originallyAvailable
                        })
        
    }

    componentDidRender() {
        window.scrollTo(0, 0)
    }

    // componentWillUnmount() {
    //     if (!this.state.saved) {
    //         this.cancelClickedHandler();
    //     }
    // }


    cancelClickedHandler = () => {
        if (this.state.deleteImageIfCancelled) {
            this.deleteImage(this.state.imageName);
        }

        this.pushBack() 
    }

    deleteImage = async (name) => {
        await storage.ref().child('images/' + name).delete();   
    }

    saveClickedHandler = async () => {


        let avail = this.state.originallyAvailable

        if (this.state.current) {
            avail = this.state.inputForm.availability.value
        }

        const dropUpdate = {
            name: this.state.inputForm.name.value,
            variant: this.state.inputForm.variant.value,
            image: this.state.currentURL,
            edition: this.state.inputForm.edition.value,
            originallyAvailable: avail,
            availability: this.state.inputForm.availability.value,
            cost: this.state.inputForm.cost.value,
            showInfo: this.state.showInfo,
            current: this.state.current,
            dropClosed: this.state.dropClosed,
            type: this.state.type,
            imageName: this.state.imageName
        }
        
        await axios.patch('/drops/' + this.props.match.params.id + '.json', dropUpdate)
            .then(response => {
                if (this.state.previousImage !== this.state.imageName) {
                    this.deleteImage(this.state.previousImage); 
                    this.setState({saved: true})
                }
               this.pushBack()
            })
        
    }

    pushBack = () => {
        if (this.props.location.lastPage === 'console'){
            this.props.history.push({
                pathname: '/admin/focus/trd/' + this.props.match.params.id,
                lastPage: 'console'})
        } else if (this.props.location.lastPage === 'archive'){
            this.props.history.push({
                pathname: '/admin/focus/trd/' + this.props.match.params.id,
                lastPage: 'archive'
            })
        }
    }


    returnButtonClickedHandler = () => {
        if (this.state.previousImage !== this.state.imageName ) {
            this.deleteImage(this.state.imageName)
        }

        this.pushBack()

    }

    checkValidity(value, rules) {        
        let isValid = true;

        if(rules.required){
            isValid = value.trim() !== '';
    
        }
        return isValid;
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedInputForm = {
            ...this.state.inputForm
        }

        const updatedFormElement = {
            ...updatedInputForm[inputIdentifier]
        }

        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = this.checkValidity(
            updatedFormElement.value, updatedFormElement.validation
        )
        updatedFormElement.touched = true;
        updatedInputForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for( let inputIdentifier in updatedInputForm){
            formIsValid = updatedInputForm[inputIdentifier].valid
            && formIsValid;
        }

        let unlockSaveBtn = false;
        
        if (formIsValid && this.state.currentURL !== '') {
            unlockSaveBtn = true;
        }

        this.setState({inputForm: updatedInputForm,
                        formIsValid: formIsValid,
                        unlockSave: unlockSaveBtn});
    }


    uploadImageHandler = async () => {

        const randomSalt = this.getRandomString();

        const name = this.state.image.name + randomSalt;

        const uploadTask = storage.ref('images/' + name).put(this.state.image);
        uploadTask.on(
            "state_changed",
            snapshot => {
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress: progress});
            },
            error => {
                console.log(error);
            },
            () => {
                storage
                    .ref("images")
                    .child(name)
                    .getDownloadURL()
                    .then(url => {                    
                        this.setState({currentURL: url, 
                            unlockSave: this.state.formIsValid,
                            imageName: name,
                            deleteImageIfCancelled: true})
                        })
                    }
            );
    }

    handleChange = event => {
        if (event.target.files[0]) {          
            this.setState({image: event.target.files[0]})
        }
        
        setTimeout( () => {
            this.uploadImageHandler();
        }, 100);    
    }

    getRandomInt = () => {
        return Math.floor(Math.random() * Math.floor(8)) + 1
    }

    getRandomString = () => {
        let result = '';
        let i;
        for (i = 0; i < 10; ++i) {
            result += this.getRandomInt();
        }

        for(let i = 0; i < this.getRandomInt(); ++i) {
            if ( this.getRandomInt() >= 3 ) {   // random mutations
                result += this.getRandomInt();
            } 
        }

        return result;
    }

    render() {

        
       

        const formElementsArray = [];
        for (let key in this.state.inputForm){
            formElementsArray.push({
                id: key,
                config: this.state.inputForm[key]
            })
         
        }

        let form = (
            <form onSubmit={this.contactMessageHandler}>
                {formElementsArray.map(formElement => (
                    <Input key={formElement.id}
                    elementType={formElement.config.elementType} 
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation.required}
                    touched={formElement.config.touched}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    name={formElement.config.name}/>
               ))}
            </form>
        )

       

        let image = <img src={noImage} 
            alt='not Found' className={classes.Image}/>


        if (this.state.progress !== 100) {
            image = <Spinner/>
        }



        if (this.state.currentURL.length > 0 && this.state.progress === 100) {
            image = <img src={this.state.currentURL} 
            alt='404: not Found' className={classes.Image}/>
        }


        let redirect = null

        if (!this.props.isAuth) {
            redirect = <Redirect to="/signin" />
        }

        return (
            <Aux>
                {redirect}
                <div className={classes.ReturnButton} >
                    <div className={classes.ReturnButtonHelper}
                        onClick={this.returnButtonClickedHandler}>
                        <img 
                            src={backIcon}
                            alt="not found" />
                    </div>
                </div>
 
                <div className={classes.TopArea}>
                    {image}
                    
                    <div className={classes.ImageUploadGroup}  >
                        <div className={classes.FileButton}>
                            <input type="file" onChange={this.handleChange} />
                        </div>
                      
                    </div>
                    
                </div>
                <div className={classes.Form}>
                    {form}
                
                    <div className={classes.BottomArea}>
                        <Button btnType="Cancel"
                            clicked={this.cancelClickedHandler}>
                            CANCEL
                        </Button>
                        <div className={classes.SpaceBetween}></div>
                        <Button btnType="Submit" disabled={!this.state.unlockSave}
                            clicked={this.saveClickedHandler}>
                            SAVE
                        </Button>
                    </div>
                </div>   
        </Aux>  
            
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isAuth: state.token !== null 
    }
}

export default connect(mapStateToProps)(withErrorHandler(TrdEdit, axios))



// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdEdit/TrdEdit.js